/**
 * @Description This is FasatButton component page.
 * This is a wrapper on "Button" component from MUX without adding any custom functionlities
 * @FileName fasatButton.js
 * @Author UMA DUTTA-duttuma
 * @CreatedOn 29 January, 2021 6:00:00
 * @IssueID CDTFASATMOD- 502
 */
import React from 'react';
import { Button } from '@manulife/mux';
import './fasatButton.scss';

function FasatButton(props) {
  const { variant, children, noCustomStyle, ariaLabel, ...rest } = props;
  // Use MUX default styles for tertiary back (and when explicitly requested)
  const normalizedVariant = (variant === 'tertiary_back' || variant === Button.VARIANT.TERTIARY_BACK)
    ? Button.VARIANT.TERTIARY_BACK
    : variant;

  return (
    <Button
      {...rest}
      aria-label={ariaLabel}
      variant={normalizedVariant}
      customStyle={{
        buttonStyle: {
          padding: '12px 4px',
          width: 'max-content',
        },
      }}
    >
      {children}
    </Button>
  );
}

export default FasatButton;
